import PropertyValueCard from "./PropertyValueCard";

const PropertyValueCardContainer = ({
  propertyValueChart,
  activePosition,
}: {
  propertyValueChart: any;
  activePosition: 10 | 20 | 30;
}) => {
  return (
    <PropertyValueCard
      propertyValueChart={propertyValueChart}
      activePosition={activePosition}
    />
  );
};

export default PropertyValueCardContainer;
